import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";

import taxStatementsLogo from "../../assets/EmployeePortal LP Tax.svg";
import payslipsLogo from "../../assets/EmployeePortal LP Payslips.svg";
import skillsLogo from "../../assets/EmployeePortal LP SkillsExperience.svg";
import profileLogo from '../../assets/LP_MyProfile.svg'
import payrollLogo from '../../assets/Payroll.svg'

const HomeLanding = ({
    userName,
    showSkillsExp,
    showPayslips,
    setMenuOptions,
    onTileClick,
    setLocation={setLocation},
}) => {
    useEffect(() => {
        setMenuOptions("Home");
    }, []);

    function handleTileClick(link) {
        onTileClick(link.url);
    }

    const getTiles = () => {
        const options = new Array();
        
        options.push({
            url: "/ProfileLanding",
            image: profileLogo,
            title: "My Profile",
            description: "View and Update your Profile.",
        });

        if(showPayslips) {
            options.push({
                url: "/PayrollLanding",
                image: payrollLogo,
                title: "Payroll",
                description: "View and Update your Payroll information.",
            });
        }

        if (showSkillsExp) {
            options.push({
                url: "/Skillslanding",
                image: skillsLogo,
                title: "Skills & Experience",
                description:
                    "Maintain your Professional Skills and Experience.",
            });
        }

        return options;
    };

    return (
        <div className="home-landing">
            <Row className="mb-4">
                <Col className="text-center">
                    <h1>
                        Hello
                        {userName ? " " + userName : ""}!
                    </h1>
                </Col>
            </Row>
            {/* <Row className="mb-5">
                <Col className="text-center">
                    <p>
                        Reserve this space for future announcements.
                    </p>
                </Col>
            </Row> */}
            <Row className="d-flex justify-content-center">
                {getTiles().map((link, i) => (
                    <Col className="col-12 col-md-3 mx-4 mb-5 text-center">
                        <img
                            onClick={() => handleTileClick(link)}
                            style={{
                                cursor: 'pointer',
                                height: '100%'
                            }}
                            src={link.image}
                            className="w-50 mb-3 link-icon"
                            title={link.description}
                            data-toggle="tooltip"
                            data-placement="top"
                        />
                        <br/>
                        <b className="mb-5">{link.title}</b>
                    </Col>
                ))
                }
            </Row>
        </div>
    );
};

export default HomeLanding;
